var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("MobileAppBar", {
        attrs: { title: _vm.appbarTitle, belowVisible: _vm.belowVisible },
      }),
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0 mb-5", attrs: { cols: "12" } },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-2", attrs: { cols: "12", align: "right" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-0 pa-0 mr-2",
                  attrs: {
                    width: "auto",
                    height: "auto",
                    id: "back_clean_btn",
                    elevation: "0",
                  },
                  on: {
                    click: function ($event) {
                      _vm.viewDrawer = false
                    },
                  },
                },
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0",
                    attrs: {
                      "max-height": "2rem",
                      "max-width": "2rem",
                      src: require("@/assets/images/array_btn.png"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-0 pa-0 mr-2",
                  attrs: {
                    width: "auto",
                    height: "auto",
                    id: "back_clean_btn",
                    elevation: "0",
                  },
                  on: {
                    click: function ($event) {
                      _vm.viewDrawer = true
                    },
                  },
                },
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0",
                    attrs: {
                      "max-height": "2rem",
                      "max-width": "2rem",
                      src: require("@/assets/images/drawer_btn.png"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.viewDrawer == false && _vm.streamingUrlLoading == false
            ? [
                _c(
                  "v-row",
                  _vm._l(_vm.videoStreamList, function (item, index) {
                    return _c(
                      "v-col",
                      {
                        key: index,
                        ref: "thumbnailRefArr",
                        refInFor: true,
                        staticClass: "ma-0 pa-4 pt-2 pb-2",
                        class: {
                          non_display:
                            _vm.videoStreamList[index] == undefined ||
                            _vm.streamingUrlLoading,
                        },
                        attrs: { cols: _vm.getColumnCount(), align: "center" },
                      },
                      [
                        item.streamAble == true
                          ? _c(
                              "v-col",
                              {
                                staticClass: "thumbnail_box ma-0 pa-0",
                                staticStyle: { cursor: "pointer" },
                                attrs: { cols: "12" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goVideoPlayer(index)
                                  },
                                },
                              },
                              [
                                !_vm.imgLoaders[index].error
                                  ? _c("v-img", {
                                      staticClass: "ma-0 pa-0",
                                      staticStyle: {
                                        height: "100%",
                                        width: "100%",
                                      },
                                      attrs: { src: item.thumbnail },
                                      on: {
                                        load: function ($event) {
                                          return _vm.onLoad(index)
                                        },
                                        error: function ($event) {
                                          return _vm.onError(index)
                                        },
                                      },
                                    })
                                  : _c(
                                      "v-img",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: {
                                          height: "100%",
                                          width: "100%",
                                        },
                                        attrs: {
                                          src: require("@/assets/images/grey_background.png"),
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              id: "thumbnail_device_status",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "ma-0 pa-0" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.t("thumbnailError")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                _vm.streamingUrlLoading == false
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-2 ellipsis",
                                        attrs: {
                                          cols: "12",
                                          id: "thumbnail_title_box",
                                          align: "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.cameraName) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.imgLoaders[index].loading
                                  ? _c("v-skeleton-loader", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        id: "img_skeleton",
                                        width: "100%",
                                        height: "100%",
                                        boilerplate: false,
                                        elevation: "0",
                                        dark: "",
                                        type: "image",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "v-col",
                              {
                                staticClass: "thumbnail_box ma-0 pa-0",
                                staticStyle: { cursor: "pointer" },
                                attrs: { cols: "12" },
                                on: {
                                  click: function ($event) {
                                    return _vm.noUrlGoVideoPlayer(index)
                                  },
                                },
                              },
                              [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: {
                                    height: "100%",
                                    width: "100%",
                                  },
                                  attrs: {
                                    src: require("@/assets/images/grey_background.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { id: "thumbnail_device_status" },
                                  },
                                  [
                                    _c("v-col", { staticClass: "ma-0 pa-0" }, [
                                      _vm._v(_vm._s(_vm.t("offline"))),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.streamingUrlLoading == false
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-2 ellipsis",
                                        attrs: {
                                          cols: "12",
                                          id: "thumbnail_title_box",
                                          align: "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.cameraName) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ],
                      1
                    )
                  }),
                  1
                ),
                _vm.videoStreamList.length == 0 &&
                _vm.streamingUrlLoading == false
                  ? _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-15",
                        attrs: { cols: "12", align: "center" },
                      },
                      [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                    )
                  : _vm._e(),
              ]
            : _vm._l(_vm.videoStreamList, function (item, index) {
                return _c(
                  "v-col",
                  {
                    key: index,
                    ref: "thumbnailRefArr",
                    refInFor: true,
                    staticClass: "ma-0 pa-2 pt-0 pb-0",
                    class: {
                      non_display:
                        _vm.videoStreamList[index] == undefined ||
                        _vm.streamingUrlLoading,
                    },
                    attrs: { cols: "12", align: "center" },
                  },
                  [
                    item.streamAble == true
                      ? _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-1 thumbnail_box_drawer",
                            staticStyle: { cursor: "pointer" },
                            attrs: { align: "center" },
                            on: {
                              click: function ($event) {
                                return _vm.goVideoPlayer(index)
                              },
                            },
                          },
                          [
                            !_vm.imgLoaders[index].error
                              ? _c("img", {
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: {
                                    height: "3.5rem",
                                    width: "3.5rem",
                                  },
                                  attrs: { src: item.thumbnail },
                                  on: {
                                    load: function ($event) {
                                      return _vm.onLoad(index)
                                    },
                                    error: function ($event) {
                                      return _vm.onError(index)
                                    },
                                  },
                                })
                              : _c("img", {
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: {
                                    height: "3.5rem",
                                    width: "3.5rem",
                                  },
                                  attrs: {
                                    src: require("@/assets/images/grey_background.png"),
                                  },
                                }),
                            _vm.streamingUrlLoading == false
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pl-2 ellipsis2",
                                    attrs: { cols: "10", align: "left" },
                                  },
                                  [_vm._v(" " + _vm._s(item.cameraName) + " ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-1 thumbnail_box_drawer",
                            staticStyle: { cursor: "pointer" },
                            attrs: { align: "center" },
                            on: {
                              click: function ($event) {
                                return _vm.noUrlGoVideoPlayer(index)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "ma-0 pa-0",
                              staticStyle: {
                                height: "3.5rem",
                                width: "3.5rem",
                              },
                              attrs: {
                                src: require("@/assets/images/grey_background.png"),
                              },
                            }),
                            _vm.streamingUrlLoading == false
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pl-2 ellipsis2",
                                    attrs: { cols: "10", align: "left" },
                                  },
                                  [_vm._v(" " + _vm._s(item.cameraName) + " ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                )
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }